module.exports = __webpack_public_path__ + "img/s4.2d089c80.png";